import React, { useState, useRef, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import { isSessionValid, getSessionGroups } from '../service/CognitoAuthService';

export default function ProtectedRoute({ authGroups, children, redirectPath }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const isAuthorized = useRef(false);
  const [isValid, setIsValid] = useState(false);

  const checkAuthorizedUser = useCallback(async () => {
    try {
      const isValidC = await isSessionValid();
      setIsValid(isValidC);
      if (isValidC) {
        const groups = await getSessionGroups();
        if (groups && groups.length && groups.some((g) => authGroups.includes(g))) {
          isAuthorized.current = true;
        }
      }
    } catch {
      isAuthorized.current = false;
    } finally {
      setIsLoading(false);
    }
  }, [authGroups]);

  React.useEffect(() => {
    checkAuthorizedUser();
  }, [checkAuthorizedUser]);

  return (
    <div>
      {isLoading && (
        <div>
          <Box sx={{ width: '100%' }}>Loading page...</Box>
        </div>
      )}
      {!isLoading && isAuthorized.current && <Outlet />}
      {!isLoading && !isAuthorized.current && navigate(redirectPath)}
    </div>
  );
}

ProtectedRoute.propTypes = {
  authGroups: PropTypes.arrayOf.isRequired,
  redirectPath: PropTypes.string,
  children: PropTypes.node,
};

ProtectedRoute.defaultProps = {
  redirectPath: '/app/dashboard',
  children: undefined,
};
